import {ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import {DepotModel} from "../../../../depots/angular/models/depot.model";
import {Address} from "../../../../addresses/models/address.model";

require('./planning-draft-route-job-split-by-location.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-route-job-split-by-location',
  templateUrl: './planning-draft-route-job-split-by-location.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftRouteJobSplitByLocationComponent implements OnInit{

  public job: any;
  public depots: DepotModel[] = [];
  public event: any;

  initialTaskDetails: {from: Address, to: Address};
  selectedDepot: DepotModel | null = null;
  excludedDepotIds: string[] = [];

  @Output() onClose = new EventEmitter();
  @Output() onInsertStop = new EventEmitter<DepotModel>();

  constructor(@Inject(PANEL_DATA) public data: { job: any, depots: DepotModel[], event: any }) {
  }

  ngOnInit() {
    this.job = this.data.job;
    this.depots = this.data.depots;
    this.event = this.data.event;

    this.excludedDepotIds = this.job.stops.map(stop => stop.depotId);

    this._initInitialTaskDetails();
  }

  onDepotSelected($event) {
    this.selectedDepot = $event.depot;
  }

  insertStop() {
    if(!this.selectedDepot) return
    this.onInsertStop.emit(this.selectedDepot)
    this.close();
  }

  close() {
    this.onClose.emit();
  }

  private _initInitialTaskDetails() {
    const stopPickUpAddress: Address = this._getStopAddress(this.job.stops.find(stop => stop.stopType === 'Pickup'));
    const stopDropoffAddress: Address = this._getStopAddress(this.job.stops.find(stop => stop.stopType === 'Dropoff'));

    this.initialTaskDetails = {
      from: stopPickUpAddress,
      to: stopDropoffAddress
    }

  }

  private _getStopAddress(stop) {
    if(stop && stop.address) {
      return stop.address
    } else{
      return null;
    }
  }

  private _actualAddress(address: Address): string {
    return address?.place ? address.place :
        address?.address1 ? address.address1 :
        address.address2;
  }
}
